import eventoTeste from '../../services/FiltrosApi/eventosTeste';

export const parametrosInicialState = {
    displayModal: {
        clienteDisplay: false,
        veiculosDisplay: false,
        eventoDisplay: true,
        orcamentoDisplay: false,
        pagamentoDisplay: false,
        franquiaDisplay: false,
        colaboradorDisplay: false,
        servicoDisplay: false,
        usuarioDisplay: false,
        bancoDisplay: false,
        CobrancaDisplay: false,
        contaDisplay: false,
        vistoriaDisplay: false,
        vistoriaListaDisplay: false,
        testeDisplay: false
    },
    parametroInit: {
        detalhesModal: false,
        detalhesVeic: false,
        detalhesBanco: false,
        detalhesLista: false,

        playLogin: false,

        atualizarModal: false,

        clickFora: false,
        editModal: false,

        editModalVeic: false,
        editModalBanco: false,
        editModalColab: false,
        editModalUsuario: false,

        disabled: false,
        disabledEven: false,
        disabledPag: false,
        disabledBanco: false,
        disabledSorteio: false,

        buscarCliente: false,
        buscarVeic: false,
        buscarEven: false,
        buscarBanco: false,
        buscarServico: false,

        novoCadastro: false,
        editarModelo: false,
        botaoCPF: false,

        recebedor: '',
        contaBanco: '',
        bancoouRecebedor: '',

        checkClie: false,
        checkVeic: false,
        checkBanco: false,

        loading: false,
        loadingGeo: false,
        loadBola: false,

        filtroPesquisa: '',
        filtroNome: '',
        filtroCpf: '',
        filtroPlaca: '',
        filtroCodigoEven: '',

        pesquisaCpf: false,
        pesquisaIdCliente: false,
        pesquisaIdVeiculo: false,
        pesquisaIdEvento: false,
        pesquisaPlaca: false,
        pesquisaIdUsuario: false,

        tipoOperacao: 'ENTRADA',

        DadosLocalizado: false,
        NaoLocalizado: false,
    },
    playLista: {
        playListaClie: false,
        playListaVeic: false,
        playListaBanco: false,
        playListaEven: false,
        playListaPagto: false,
        playListaBenef: false,
        playListaRelatorio: false,
        playListaUsuario: false,
        playListaCobranca: false,
    },

    playmodal: {
        playModalCliente: false,
        playModalVeiculo: false,
        playModalEven: false,
        playModalEvenPlaca: false,
        playModalDetalhesEven: false,
        playModalBenef: false,
        playModalBanco: false,
        playModalColab: false,
        playModalFranquia: false,
        playModalSorteio: false,
        playModalLogin: false,
        playModalUsuario: false,
        playModalDespesa: false,
        playModalOrcamento: false,
        playModalCobranca: false,
        playModalConta: false,
        playModalEditar: false,
        playModaVistoria: false,
        

    },

    listaPesquisa: {
        listaCliente: [],
        listaVeiculo: [],
        listaCotacao: [],
        listaEvento: [], // eventoTeste é um objeto json
        listaCondutor: [],
        listaPagamentos: [],
        listaOrcamento: [],
        listaCarnes: [],
        listaBanco: [],
        listaSorteio: [],
        listaUsuario: [],
        listaTipo: [],
        listaTipoEvento: [],
        listaItemProd: [],
        listaItem: [],
        listaItemLS: [],
        listaFornecedor: [],
        listaArquivos: [],
        listaPagina: [],
        listaFranquia: [],
        listaFiltrada: [],

        nomeItem: '',
        selectItem: '',
        categoriaItem: "",
        novoItem: '',
        valorItem: "",
        codigoAtualiza: "",
        alertaNovo: false,

        nomeTipoEvento:"",

        id_nomeForn: "",
        nomeForn: "",
        SelectForn: "",

        id_nomeUser: "",
        nomeUser: "",
        SelectUser: "",
        
    },
}
//-----------------------------------------------------
export const parametrosReducer = (state = parametrosInicialState, action) => {
    switch (action.type) {
        case 'SET_Display':
            return { ...state, displayModal: action.payload };

        case 'SET_parametroInit':
            return { ...state, parametroInit: action.payload };
            
        case 'set_playLista':
            return { ...state, playLista: action.payload };

        case 'SET_PLAYMODAL':
            return { ...state, playmodal: action.payload };

        case 'set_ListaPesquisa':
            return { ...state, listaPesquisa: action.payload };

        case 'set_limparlistaPesquisa':
            return { ...state, listaPesquisa: parametrosInicialState.listaPesquisa };

        case 'InicialPlayModal':
            return { ...state, playmodal: parametrosInicialState.playmodal };

        case 'InicialDisplayModal':
            return { ...state, displayModal: parametrosInicialState.displayModal };

        default:
            return state;

    }
};
//-----------------------------------------------------
